<script setup>
import InvoiceHeader from "./components/InvoiceHeader.vue";
import ArgonButton from "@/components/ArgonButton.vue";
//import { apiService } from "@/services/apiService";
import { invoiceService } from "@/services/invoiceService";
import { useRoute } from 'vue-router'
import { useRouter } from "vue-router";
import { ref, onMounted, onBeforeUnmount } from 'vue'

const route = useRoute()
const router = useRouter();

const canEdit = ref(true)
const error = ref(null)
const isShiftPressed = ref(false)

const Invoice = ref({
  Id: "0",
  InvoiceNumber: "#",
  ClientName:"",
  ClientAddress: "",
  InvoiceDate:"",
  TotalAmount:"0.0",
  Items:[
          // {
          //   Id: "1",
          //   ProductName: "Item1",
          //   Quantity: "1",
          //   UnitPrice: "10.0",
            
          // }
        ],
})


onMounted(() => {
  loadInvoiceById(route.params.id);
  window.addEventListener('keydown', handleKeyDown);
  window.addEventListener('keyup', handleKeyUp);
})

onBeforeUnmount(()=> {
  // Usuń nasłuchiwanie zdarzeń klawiatury, aby uniknąć wycieków pamięci
  window.removeEventListener('keydown', handleKeyDown);
  window.removeEventListener('keyup', handleKeyUp);
})


async function loadInvoiceById(id) {
   try{
    if(parseInt(id)>0){   
      const result  = await invoiceService.loadInvoice(id);
      if(result.Success){
        console.log('loadInvoice->Api->Success:', result);
        Invoice.value = result.Data;
      }
    }
   }catch(err){
      if (err.response) {
          console.error('Error response:', err.response.data);
          error.value = err.response.data;
      } else if (err.request) {
          console.error('No response received:', err.request);
      } else {
          console.error('Error setting up request:', err.message);
      }
   }
}



async function addOrUpdateInvoice(event) {
  canEdit.value = false;
  if(parseInt(Invoice.value.Id)>0){
      const result = await invoiceService.updateInvoice(Invoice.value);
      if(result.Success){
        console.log('updateInvoice->Api->Success:', result);
        //loadInvoice();
        if(!event.shiftKey){
          router.push('/invoices');
        }
      }else{
        console.log('updateInvoice->Api->Error:', result.Message, result.Error);
      }
   
  }else{
      const result  = await invoiceService.createInvoice(Invoice.value);
      if(result.Success){
        console.log('createInvoice->Api->Success:', result);
        if(!event.shiftKey){
          router.push('/invoices'); //to odsieza dane 
        }else{
          loadInvoiceById(result.Data);
          router.push('/invoice/'+result.Data);
        } //to odsieza dane 
      }else{
        console.log('updateInvoice->Api->Error:', result.Message, result.Error);
      }
  }
}

async function deleteInvoice() {
  canEdit.value = false;
  if(parseInt(Invoice.value.Id)>0){
      const result = await invoiceService.deleteInvoice(Invoice.value);
      if(result.Success){
        console.log('updateInvoice->Api->Success:', result);
        //loadInvoice();
        router.push('/invoices'); //to odsieza dane 
      }else{
        console.log('updateInvoice->Api->Error:', result.Message, result.Error);
      }
  }
  canEdit.value = true;
}

function addInvoiceItem() {
  Invoice.value.Items.push({
            Id: "0",
            ProductName: "",
            Quantity: "1",
            UnitPrice: "0.0",
            
          })
}

function removeInvoiceItem(id) {
  let i = Invoice.value.Items.map(item => item.Id).indexOf(id) // find index of your object
  Invoice.value.Items.splice(i, 1) // remove it from array
}

function handleKeyDown(event) {
  if (event.key === 'Shift') {
    isShiftPressed.value = true;
  }
}

function handleKeyUp(event) {
  if (event.key === 'Shift') {
    isShiftPressed.value = false;
  }
}


</script>
<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <invoice-header v-model="Invoice" :onSave="addOrUpdateInvoice" :onAddItem="addInvoiceItem" :onRemoveItem="removeInvoiceItem" />
      </div>
    </div>
    <hr class="horizontal dark" />
    <div class="row">
      <div class="col-10"></div>
      <div class="col-1">
        <argon-button color="danger" variant="gradient"  @click="deleteInvoice"><i>delete</i></argon-button> 
        <!-- class="fas fa-remove me-2" -->
      </div>
      <div class="col-1">
        <argon-button color="dark" variant="gradient"  @click="addOrUpdateInvoice" ><i class="fas fa-plus me-2"></i>{{ isShiftPressed?"Save":"Exit" }}</argon-button>
        <!-- <argon-button color="dark" variant="gradient"  @click.shift="addOrUpdateInvoice"><i class="fas fa-plus me-2"></i>Save</argon-button> -->
      </div>
    </div>
  </div>
</template>
